import React from "react";
import { motion } from "framer-motion";

const skills = {
  "Frontend": [
    "React",
    "JavaScript (ES6+)",
    "HTML5",
    "CSS3",
    "Tailwind CSS",
    "Framer Motion",
  ],
  "Backend": [
    "Node.js",
    "Express.js",
    "Flask",
    "MongoDB",
    "Firebase",
    "SQL",
  ],
  "Mobile": [
    "React Native",
    "Expo",
    "Android Studio",
  ],
  "AI & Data": [
    "LLMs",
    "Retrieval-Augmented Generation (RAG)",
    "Natural Language Processing (NLP)",
    "Sentiment Analysis",
    "Data Analytics",
  ],
  "Tools": [
    "Git",
    "GitHub",
    "Postman",
    "VS Code",
    "Figma",
  ],
};

// Animation variants
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const SkillSection = ({ isFullPage = false }) => {
  return (
    <section
      id="skills"
      className={`relative py-24 ${isFullPage ? "min-h-screen" : ""}`}
    >
      {/* Background glow */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-1/3 left-16 w-64 h-64 bg-blue-500/15 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-16 w-64 h-64 bg-orange-500/15 rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-24">
        {/* Title */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Skills & <span className="gradient-text">Expertise</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Technologies and tools I use to build scalable applications and
            AI-powered solutions.
          </p>
        </motion.div>

        {/* Skill Cards */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {Object.entries(skills).map(([category, items], index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              whileHover={{ y: -6 }}
              className="glass rounded-2xl p-6 transition-all"
            >
              <h3 className="text-xl font-semibold mb-4">
                {category}
              </h3>

              <div className="flex flex-wrap gap-3">
                {items.map((skill, i) => (
                  <motion.span
                    key={i}
                    whileHover={{ scale: 1.08 }}
                    className="text-sm px-4 py-2 rounded-full 
                               bg-white/5 border border-white/10 
                               text-gray-300 cursor-default"
                  >
                    {skill}
                  </motion.span>
                ))}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default SkillSection;
